import { Link, useLocation } from 'react-router-dom';
import LegalPage from '../../../components/legal/LegalPage';

export default function RegistrationComplete() {
  const { state } = useLocation();
  const smsStatus = state?.smsStatus || 'none';

  console.log('SMSSTATUS', smsStatus);

  return (
    <LegalPage title="Registration Complete">
      <div className="content">
        <p>Your MySimpleDB account setup can continue.</p>

        <p>
          SMS notifications are <strong>optional</strong> and are not required
          to use MySimpleDB.
        </p>

        {smsStatus === 'no-phone' && (
          <p>
            <b>
              SMS notifications could not be enabled because no phone number was
              provided.
            </b>
            <br />
            Your account was created successfully. You can enable SMS
            notifications later from Account Settings.
          </p>
        )}

        {smsStatus === 'phone-no-consent' && (
          <p>
            <b>SMS notifications were not enabled.</b>
            <br />
            You entered a mobile phone number, but did not opt in to receive SMS
            notifications. You can enable SMS notifications later from Account
            Settings.
          </p>
        )}

        {smsStatus === 'new' && (
          <p>
            <b>SMS notifications have been enabled.</b>
            <br />
            Thank you for choosing to receive optional account-related text
            messages from MySimpleDB. You can update your SMS preferences at any
            time from Account Settings after signing in.
          </p>
        )}

        {smsStatus === 'existing' && (
          <p>
            <b>SMS notifications are already enabled.</b>
            <br />
            Your mobile number is already enrolled to receive optional
            MySimpleDB SMS notifications. You can update your SMS preferences at
            any time from Account Settings.
          </p>
        )}

        {smsStatus === 'none' && (
          <p>
            <b>SMS notifications were not enabled.</b>
            <br />
            You can continue using MySimpleDB normally. If you change your mind,
            you can enable SMS notifications later from Account Settings.
          </p>
        )}

        <div style={{ marginTop: 32 }}>
          <Link
            to="https://mysimpledb.com/login"
            style={{
              display: 'inline-block',
              background: '#2563eb',
              color: '#fff',
              padding: '12px 24px',
              borderRadius: 6,
              textDecoration: 'none',
            }}
          >
            Continue to Sign In
          </Link>
        </div>
      </div>
    </LegalPage>
  );
}
